<script setup lang="ts">
import { CategoryTabs } from "~/types/Category";

const { categorySlug, activeFilters, activeTab } = defineProps<{
  categorySlug: string;
  activeFilters: string[];
  activeTab?: CategoryTabs;
}>();

const route = useRoute();

const isFilterMenuShown = ref(false);
const onCloseFilterMenu = () => (isFilterMenuShown.value = false);

const filterCount = computed(() => {
  const sortingApplied = transformRouteParams(route.query.sort, "string");

  const filterCount = activeFilters.length;

  return sortingApplied ? filterCount + 1 : filterCount;
});
</script>

<template>
  <div>
    <BaseFilterButton
      :filter-count="filterCount"
      page-type="categoryPage"
      @open-filter-menu="isFilterMenuShown = true"
    />
  </div>
  <BaseSheetMenu
    :is-open="isFilterMenuShown"
    display-side="right"
    @close="onCloseFilterMenu"
  >
    <CategoryEventFiltersContent
      :category-slug="categorySlug"
      :active-filters="activeFilters"
      :active-tab="activeTab ?? CategoryTabs.Live"
      @close-menu="onCloseFilterMenu"
    />
  </BaseSheetMenu>
</template>
